import {useState} from 'react'
import SvgIcon, { iconList } from '../../share/components/iconSVG'
import './styles.css'
import wordSpecialist from '../../Specialist/ButtonsFilters/wordSpecialist'

const ButtonsFilters = ({personalizerFind }) => {

    const [dropdownPersonalizeFind, setDropdownPersonalizeFind] = useState(false)
    const [dropdownCityFind, setDropdownCityFind] = useState(false)
    const [KeyWord, setKeyWord] = useState('')
    const [dropdownSpecialist, setDropdownSpecialist] = useState(false)
    const [wordSpecialistw, setWordSpecialistw] = useState('')
    const {wordSpeialist} = wordSpecialist()

  return (
    <div className='contain-btn-filters-specialist'>
            
            <button>
                <SvgIcon name={iconList.IconBeautiful} size={60} color={'#004274'} />
                <section onClick={()=>{setDropdownCityFind(!dropdownCityFind)}} className='layout-btn-specialist'>
                    <h3>
                        Servicios
                    </h3>
                    <p>Peluqueria, Maquillaje, manicure..</p>
                   
                </section>
               
            </button>
            <button >
                <SvgIcon name={iconList.IconFilters} size={60} color={'#004274'} />
                <section onClick={()=>{setDropdownPersonalizeFind(!dropdownPersonalizeFind)}} className='layout-btn-specialist' >
                    <h3>
                        Filtros
                    </h3>
                    <p>Busqueda Personalizada</p>
                    <SvgIcon name={iconList.IconArrowDown} size={30} color={'#004274'} />
                </section>
                {
                    dropdownPersonalizeFind &&
                    <div className='dropdown-personalize-find-clinics'>
                        <input type="text" onChange={(e)=>{setKeyWord(e.target.value)}}/>
                        <span onClick={()=>{
                            personalizerFind(KeyWord)
                            setDropdownPersonalizeFind(!dropdownPersonalizeFind)
                        }}>Buscar</span>
                   </div>
                }
            </button>
        </div>
  )
}

export default ButtonsFilters